import type { SaveProvider } from './SaveProvider';
import { TelegramSaveProvider } from './TelegramSaveProvider';
import { LocalStorageSaveProvider } from './LocalStorageSaveProvider';
import { InMemorySaveProvider } from './InMemorySaveProvider';

let cached: SaveProvider | null = null;

function pickProvider(): SaveProvider {
  // Приоритет: Telegram CloudStorage (если в Mini App) → localStorage (обычный браузер,
  // itch.io standalone) → in-memory (всё иное упало). Telegram SDK подключается sync
  // через <script> в index.html, к моменту main.ts уже доступен.
  if (TelegramSaveProvider.isAvailable()) {
    return new TelegramSaveProvider();
  }
  if (LocalStorageSaveProvider.isAvailable()) {
    return new LocalStorageSaveProvider();
  }
  console.warn('[saveProvider] No persistent storage available — progress will not persist between sessions');
  return new InMemorySaveProvider();
}

export function getSaveProvider(): SaveProvider {
  if (!cached) {
    cached = pickProvider();
    console.info(`[saveProvider] Using: ${cached.name}`);
  }
  return cached;
}
